// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"12":"profiler","9777":"recorder"}[chunkId] + "-" + {"12":"e52f192129cbf84da119","9777":"49586c1b639fe1ca8925"}[chunkId] + ".chunk.js";
};